export default {"src":"/_next/static/media/omni.0f7f5bca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};